import React from 'react';
import ReturnsContainer from "../containers/ReturnsContainer";

const ReturnsView = () => {

  return (
    <ReturnsContainer/>
  );
};

export default ReturnsView;
